import { environment } from '../../../environments/environment';

const DEFAULT_CALLBACK_ROUTE = 'login/callback';
const PIPELINE_TOKEN = /^#\{PROD_[A-Z0-9_]+\}#$/;

function isUsablePath(path: string): boolean {
  const trimmed = path.trim();
  return trimmed.length > 0 && !PIPELINE_TOKEN.test(trimmed);
}

/** Compose the Okta Sign-in redirect URI from app domain + callback path. */
export function eventqOktaRedirectUri(appDomain: string, callbackPath: string): string {
  const domain = appDomain.trim().replace(/\/+$/, '');
  if (!domain || PIPELINE_TOKEN.test(domain)) {
    return '';
  }
  const path = isUsablePath(callbackPath)
    ? callbackPath.trim().replace(/^\/+/, '')
    : DEFAULT_CALLBACK_ROUTE;
  return `${domain}/${path}`;
}

/** Angular route path for the Okta callback (no leading slash). */
export function eventqOktaCallbackRoute(callbackPath = environment.okta.callbackPath): string {
  if (!isUsablePath(callbackPath)) {
    return DEFAULT_CALLBACK_ROUTE;
  }
  return callbackPath.trim().replace(/^\/+/, '');
}

/** Redirect URI from the current page origin + callback path (falls back to env domain). */
export function eventqOktaRedirectUriFromEnv(
  pageOrigin = typeof globalThis !== 'undefined' ? (globalThis.location?.origin ?? '') : '',
): string {
  return eventqOktaRedirectUri(
    pageOrigin.trim() || environment.eventqAppBaseUrl,
    environment.okta.callbackPath,
  );
}
